import { GeneratorType } from '../../types/game-types';
import { unitStats } from '../../stats';
import styles from './styles.module.scss';
import { humanNumber } from '@game-libs/exc-libs';
import { Icon } from '../Icon';
import { useTranslation } from 'react-i18next';
import { useUpgradesStore } from '../../store/zustand/useUpgradesStore';
import { useGeneratorsStore } from '../../store/zustand/useGeneratorsStore';
import { getModifiedTicksToGenerate } from '../../store/helpers/get-modified-ticks-to-generate';

export const UnitStats = ({ generatorType }: { generatorType: GeneratorType }) => {
  const { t } = useTranslation('statistics');
  const upgrades = useUpgradesStore((store) => store.upgrades);
  const generators = useGeneratorsStore((store) => store.generators);

  const stats = unitStats[generatorType];
  const generator = generators[generatorType];
  const ticksToGenerate = getModifiedTicksToGenerate(upgrades[generatorType], generator, generatorType);

  const showGeneration = Boolean(
    stats.damagePerTick !== undefined ||
      stats.inspirationGeneration !== undefined ||
      stats.goldGeneration !== undefined ||
      stats.unitsGeneration !== undefined ||
      stats.buildingsGeneration !== undefined,
  );

  const showCritical = Boolean(
    (stats.criticalChance && stats.criticalChance > 0) || (stats.criticalDamage && stats.criticalDamage > 0),
  );

  if (!showGeneration && !showCritical) {
    return null;
  }

  return (
    <div className={styles.statsContainer}>
      {showGeneration && (
        <div className={styles.section}>
          {/* <div>{t('generationSection')}</div> */}

          {stats.damagePerTick !== undefined ? (
            <div className={styles.stat}>
              <Icon iconId={'damage'} />
              <div>
                {humanNumber(stats.damagePerTick! / ticksToGenerate, 3)}
                {t('perSec')}
              </div>
            </div>
          ) : null}

          {stats.goldGeneration !== undefined ? (
            <div className={styles.stat}>
              <Icon iconId={'gold'} />
              <div>
                {humanNumber(stats.goldGeneration! / ticksToGenerate, 3)}
                {t('perSec')}
              </div>
            </div>
          ) : null}

          {stats.unitsGeneration !== undefined ? (
            <div className={styles.stat}>
              <Icon iconId={'unit'} />
              <div>
                {humanNumber(stats.unitsGeneration! / ticksToGenerate, 3)}
                {t('perSec')}
              </div>
            </div>
          ) : null}

          {stats.buildingsGeneration !== undefined ? (
            <div className={styles.stat}>
              <Icon iconId={'tower'} />
              <div>
                {humanNumber(stats.buildingsGeneration! / ticksToGenerate, 3)}
                {t('perSec')}
              </div>
            </div>
          ) : null}

          {stats.inspirationGeneration !== undefined ? (
            <div className={styles.stat}>
              <Icon iconId={'inspiration'} />
              <div>
                {humanNumber(stats.inspirationGeneration! / ticksToGenerate, 3)}
                {t('perSec')}
              </div>
            </div>
          ) : null}
        </div>
      )}

      {showCritical && (
        <div className={styles.section}>
          <div>{t('critSection')}</div>
          <div>
            {stats.criticalChance !== undefined ? (
              <div className={styles.stat}>
                <Icon iconId={'dice'} />
                <div>{humanNumber(stats.criticalChance!)}%</div>
              </div>
            ) : null}

            {stats.criticalChance && stats.criticalChance > 0 && stats.criticalDamage && stats.criticalDamage > 0 ? (
              <div className={styles.stat}>
                <Icon iconId={'crit'} />
                <div>{humanNumber(stats.criticalDamage!)}</div>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};
